import {Button} from "react-bootstrap";
import React from "react";

export const JuliusClash = (props) => {

    const [nbGames, setNbGames] = React.useState(0);

    function startGame() {
        props.socketAnniv.emit("anniv2025-startJC", JSON.stringify({}));
    }

    return <div>
        <h1>Julius Clash</h1>
        <div>
            <Button onClick={startGame}>
                Start Game
            </Button>
        </div>
        <br/>
        <br/>
        <div>
            <h2>Points</h2>
            {
                props.juliusClashPoints && Object.keys(props.juliusClashPoints).map((playerId) => {
                    return <div key={playerId}>
                        {playerId}: {props.juliusClashPoints[playerId]} points
                    </div>
                })
            }
        </div>
        <br/>
        <br/>
        <div>
            Nb Games : {nbGames}
            <br/>
            <Button onClick={() => {
                setNbGames(nbGames + 1);
            }}>
                +1
            </Button>
            <Button onClick={() => {
                setNbGames(nbGames - 1);
            }}>
                -1
            </Button>
        </div>
        <br/>
        <br/>
        <div>
            <h2>Send Score</h2>
            <Button disabled={nbGames === 0} onClick={() => {
                const updatedPoints = { ...props.state.points };
                for(const playerId of Object.keys(props.juliusClashPoints || {})){
                    const player = Object.keys(props.state.points).find(p => p === playerId);
                    if(player && nbGames){
                        if(!updatedPoints[player]){
                            updatedPoints[player] = 0;
                        }
                        updatedPoints[player] += Math.floor((props.juliusClashPoints[playerId] / nbGames));
                    }
                }
                Object.keys(props.juliusClashPoints).forEach(key => {
                    props.juliusClashPoints[key] = 0;
                });
                props.newState({...props.state, points: updatedPoints, juliusClash: undefined});
            }}>
                Send Score
            </Button>
        </div>
    </div>
}